import {create} from "zustand";
import dayjs from "dayjs";

export const useSelectedMealStore = create(( get, set) => (
    {
        currentDate: dayjs(),
        currentMeal: 'lunch',
    }
))